import { pageSEO } from "@/lib/seo";
import AdvancedSEOHead from "@/components/seo/AdvancedSEOHead";
import StructuredData from "@/components/seo/StructuredData";
import LLMFriendlyContent, { defaultPageFacts } from "@/components/seo/LLMFriendlyContent";
import CosmosWaveHome from "@/components/CosmosWaveHome";

export default function Index() {
  return (
    <>
      <AdvancedSEOHead
        title={pageSEO.home.title}
        description={pageSEO.home.description}
        canonical={pageSEO.home.canonical}
        ogImage="/og/home-1200x630.jpg"
        ogType="website"
        keywords={pageSEO.home.keywords}
      />

      {/* Page-specific structured data */}
      <StructuredData 
        enableOrganization={false} // Already in AdvancedSEOHead
        enableWebsite={false} // Already in AdvancedSEOHead
        enableBreadcrumbs={false} // Home page doesn't need breadcrumbs
      />

      <main className="min-h-screen">
        <CosmosWaveHome />
      </main>
    </>
  );
}